import React from 'react';
import { Card } from "react-bootstrap";
import face_image from "../../assets/img/faceIstvanSajtos.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projSajtosI_lattices.png";

const Istvan_Sajtos_lattices = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_image}
              /* this will be the text on the banner */
              alt="The structural and the material symmetry of single and double-layer lattices"
            />{" "}
            <p className="text7">István Sajtos </p>
            <br />
            <p className="text8">
              Associate Professor{" "}
            </p>
            <p className="text8">Department of Mechanics, Materials and Structures, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>

            Natural and man-made objects and materials exhibit many kinds of symmetries based on their geometrical structures, 
            independently of size. The biological meta-materials on the micro scale, while the space trusses, used for building 
            roof structure, on the macro scale have a unit cell architecture. Unit cell architecture means repeating the unit 
            cells periodically by translation in the plane or in space to make the whole structure. The same connected bar 
            system is in each unit cell. The mechanical and physical behaviour, e.g., elastic deformation, of these lattices is 
            defined by the discrete unit cell bar system.
            <br/>
            <br/>
            It is a general technique that, instead of the large-discrete-bar system, an equivalent continuum model is analysed, 
            e.g., plate or shell model, to determine the structural behaviour under different loads. The symmetry properties of 
            the unit-cell discrete bar system determine the physical response, and the physical properties of the replacement 
            continuum, such as the elasticity matrix. The elasticity matrix relates the stresses and strains at a material point 
            in a continuum model; its elements are the stiffnesses.
            <br/>
            <br/>
            The material symmetry is the symmetry properties of the elasticity matrix. There are eight different material 
            symmetries while there are seven space groups of three dimensional lattices.
            <br/>
            <br/>
            The main task of the research:
            <br/>
            <br/>
            There are several lattice geometries used for building roof applications. Find the unit cell of these lattices, if 
            only translation is used for plane or space filling, or other operations may also be used. Determine the symmetry 
            properties of these lattices, and find the corresponding material symmetry if the replacement continuum is a material, 
            plate, or shell.
            <br/>
            <br/>
            It is presumably useful to use the Bravais lattices as a starting point if possible.
            <br/>
            <br/>
            References:

            <ul>
                <li>
                    A. Bóna , I. Bucataru , M. A. Slawinski: Material symmetries of elasticity tensors
                    The Quarterly Journal of Mechanics and Applied Mathematics, Vol. 57, Issue 4, 2004, pp. 583–598,{" "} 
                    <a href="https://doi.org/10.1093/qjmam/57.4.583">https://doi.org/10.1093/qjmam/57.4.583</a>

                </li>
                <li>
                    Kollár, L.P. – Springer, G.S.: Mechanics of composite structures
                    Cambridge University Press, 2009.
                </li>
                <li>
                    M. Negahban – A. S. Wineman: Material symmetry and the evolution of anisotropies in a simple material—I. 
                    Change of reference configuration; II. The evolution of material symmetry, International Journal of 
                    Non-Linear Mechanics, Vol. 24, Issue 6, 1989., pp. 521-549,{" "}
                    <a href="https://doi.org/10.1016/0020-7462(89)90017-6.">https://doi.org/10.1016/0020-7462(89)90017-6</a>.;{" "} 
                    <a href="https://doi.org/10.1016/0020-7462(89)90018-8">https://doi.org/10.1016/0020-7462(89)90018-8</a>.
                </li>
                <li>
                    A.V. Shubnikov – V.A. Koptsik: Symmetry in science and art Plenum Press, 1974.
                </li>
            </ul>


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Istvan_Sajtos_lattices;